import { render, staticRenderFns } from "./CompareData.vue?vue&type=template&id=18656039"
import script from "./CompareData.vue?vue&type=script&lang=js"
export * from "./CompareData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports